import { Line } from '@mm/components';
import { useActor } from '@xstate/react';
import React, { useState } from 'react';
import { useContextSelector } from 'use-context-selector';
import { LiveChatContext } from '../../../LiveChatContext';
import { LcSearchStates } from '../../../liveChatMachine';
import { FoundContacts } from './FoundContacts';
import { FoundConversations } from './FoundConversations';
import './shared.pcss';

export const SearchResults = () => {
  const [selectedContactsContactId, setSelectedContactsContactId] = useState<
    string | undefined
  >(undefined);
  const [selectedConversationsContactId, setSelectedConversationsContactId] =
    useState<string | undefined>(undefined);

  const lcService = useContextSelector(
    LiveChatContext,
    v => v.lcServiceRef.current!,
  );

  const [lcMachineState] = useActor(lcService);

  const { searchString, foundContacts, foundConversations } =
    lcMachineState.context;

  if (searchString.length <= 1) {
    return null;
  }

  if (
    !lcMachineState.matches({
      mainLogic: { active: { contactSearch: LcSearchStates.searching } },
    }) &&
    !lcMachineState.matches({
      mainLogic: { active: { conversationSearch: LcSearchStates.searching } },
    }) &&
    foundContacts.length === 0 &&
    foundConversations?.matchesTotal === 0
  ) {
    return (
      <div className="lc-search-results--empty">
        Nothing found for '{searchString}'.
      </div>
    );
  }

  return (
    <div className="lc-search-results">
      <div className="lc-search-results--section">
        <FoundContacts
          selectedContactsContactId={selectedContactsContactId}
          selectedConversationsContactId={selectedConversationsContactId}
          setSelectedContactsContactId={setSelectedContactsContactId}
          setSelectedConversationsContactId={setSelectedConversationsContactId}
        />
      </div>
      <Line />
      <div className="lc-search-results--section">
        <FoundConversations
          setSelectedContactsContactId={setSelectedContactsContactId}
          selectedContactsContactId={selectedContactsContactId}
          selectedConversationsContactId={selectedConversationsContactId}
          setSelectedConversationsContactId={setSelectedConversationsContactId}
        />
      </div>
    </div>
  );
};
